/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Growth_Search_WordsInputs */



/**
* | output |
* | --- |
* | "members, joins, leavers, net growth, retention, join sources, boosts" |
*
* @param {View_Growth_Search_WordsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const view_growth_search_words = /** @type {((inputs?: View_Growth_Search_WordsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Growth_Search_WordsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("участники, входы, приходы, уходы, ушедшие, чистый прирост, удержание, источники входа, бусты")
	return /** @type {LocalizedString} */ ("members, joins, leavers, net growth, retention, join sources, boosts")
});